import { render } from "./Organisational.vue?vue&type=template&id=3650cd64"
import script from "./Organisational.vue?vue&type=script&lang=js"
export * from "./Organisational.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__